const styles = (theme) => ({
    TextContainer:{
        backgroundColor: 'white',
        padding: '40px 60px',
        width: '80%',
        borderRadius: '5px',
        boxShadow: '2px 2px 5px rgba(200,200,200,0.6)',
        marginBottom: '20px'
    }
});

export default styles;